/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentViewModel } from "../types/StudentViewModel.ts";

export const studentViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  ra: z.string().nullish(),
  curriculum: z.string().nullish(),
  codeUsp: z.string().nullish(),
  perfilPublic: z.optional(z.boolean()),
}) as unknown as ToZod<StudentViewModel>;
